// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';

const ClaimValueSummaryItem = props =>
    <li className='claim-value-summary-list-item'>
        <div className='label'>
            <FormattedMessage id={props.label}/>
        </div>
        <div className='amount'>
            <span>{props.amount}</span>
        </div>
    </li>;

ClaimValueSummaryItem.displayName = 'ClaimValueSummaryItem';
ClaimValueSummaryItem.propTypes = {
    amount: PropTypes.string.isRequired,
    currency: PropTypes.instanceOf(KeyValuePair).isRequired,
    label: PropTypes.string.isRequired
};

export default ClaimValueSummaryItem;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-value-summary/claim-value-summary-item.js